import Vue from 'vue';
import VueRouter from 'vue-router';

import Welcome from '@/pages/Welcome';
import Home from '@/pages/Home';
import Stores from '@/pages/Stores';
import Product from '@/pages/Product';

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '*',
            redirect: '/',
        },
        {
            path: '/',
            name: 'Welcome',
            component: Welcome,
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
        },
        {
            path: '/stores',
            name: 'Stores',
            component: Stores,
        },
        {
            path: '/product',
            name: 'Product',
            component: Product,
        },
    ],
});


// WEBPACK FOOTER //
// ./src/router/index.js